import axios from 'axios';
import { config_headers, servicelist, URL_API } from '../Config';

export const pSupervisorRequest1_Info = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            await axios.post(URL_API(`${servicelist.SupervisorService}p_supervisor_request_1_info`), body, authorization )
                .then(res => {
                    resolve(res);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}


export const pSupervisorRequest1_update = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            await axios.post(URL_API(`${servicelist.SupervisorService}p_supervisor_request_1_update`), body, authorization )
                .then(res => {
                    resolve(res);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}
